import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Division extends EntityDto implements IEntityDto {
    Division_Id: string;
    DivisionName: string; 
    Code:string;
    Emp_Ref_Id: string;
    EmployeeName: string;
    Phone: string;
    EmailId: string;
    Company_Id: string;
    CompanyName: string;
    Zone_Id: string;
    ZoneName: string;
    State_Id: string;
    StateName: string;
    Region_Id: string;
    RegionName: string;
    TotalCount: number;
    IsActive: boolean;
    
    constructor() {
        super();
        this.Division_Id = "00000000-0000-0000-0000-000000000000";
        this.DivisionName = "";
        this.Code="";
        this.EmailId = "";
        this.Phone = "";
        this.Emp_Ref_Id = '';
        this.EmployeeName = '';
        this.Company_Id = "";
        this.CompanyName = ""; 
        this.Zone_Id = "";
        this.ZoneName = ""; 
        this.State_Id = "";
        this.StateName = ""; 
        this.Region_Id="";
        this.RegionName ="";
        this.TotalCount = 0; 
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'DivisionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Area Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' }, 
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            //{ FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },     
            //{ FieldName: 'State_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State is required' },     
        ];
    }
}
